import Cookies from 'js-cookie';

const app = {
    state: {
        sidebar: {//侧边栏折叠状态
            opened: !+Cookies.get('sidebarStatus')
        },
        visitedViews: [],//访问过的路由
        fold: false,//查询框条件栏的折叠
        taskStatus: ''//是否有生码任务
    },
    mutations: {
        ADD_VISITED_VIEWS: (state, view) => {
            if (state.visitedViews.some(v => v.path === view.path)) return;
            state.visitedViews.push({name: view.path == '/admin' ? '首页' : view.name, path: view.path});
        },
        DEL_VISITED_VIEWS: (state, view) => {
            let index
            for (const [i, v] of state.visitedViews.entries()) {
                if (v.path === view.path) {
                    index = i
                    break
                }
            }
            state.visitedViews.splice(index, 1);
        },
        FOLD: state => {
            state.fold = !state.fold;
        },
        TASK: (state, status) => {
            state.taskStatus = status;
        },
        CLEAR_VISITED_VIEWS: (state) => {
            state.visitedViews = [];
        },
        TOGGLE_SIDEBAR: state => {
            if (state.sidebar.opened) {
                Cookies.set('sidebarStatus', 1);
            } else {
                Cookies.set('sidebarStatus', 0);
            }
            state.sidebar.opened = !state.sidebar.opened;
        }
    },
    actions: {
        addVisitedViews: ({commit}, view) => {
            commit('ADD_VISITED_VIEWS', view);
        },
        delVisitedViews: ({commit}, view) => {
            commit('DEL_VISITED_VIEWS', view);
        },
        taskMission: ({commit}, status) => {
            return new Promise((resolve, reject) => {
                commit('TASK', status);
                resolve();
            });
        },
        toggleSidebar: ({commit}) => {
            commit('TOGGLE_SIDEBAR');
        }
    }
};

export default app;



// WEBPACK FOOTER //
// ./src/other/store/modules/app.js